import { Component, OnInit } from '@angular/core';
import { AdminService, BaseGraphQueryModel } from "../../../services/admin/admin.service";
import { UserService } from "../../../services/user/user.service";
import * as moment from 'moment';
import { Message } from 'primeng/components/common/api';
import { saveAs } from "file-saver";

@Component({
	selector: 'app-user-dashboard',
	templateUrl: './user-dashboard.component.html',
	styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit {
	error: Message[];
	dateRange: Date[];
	dateSelectionRanges;
	maxDate = moment().endOf("day").toDate();

	
	queryModel: BaseGraphQueryModel;
	date: moment.Moment;
	sixMonths: moment.Moment;
	threeMonths: moment.Moment;
	oneMonths: moment.Moment;
	sevenDays: moment.Moment;
	oneDay: moment.Moment;

	userCount = null;

	userCountSixMonth = null;
	userCountThreeMonth = null;
	userCountOneMonth = null;
	userCountSevenDays = null;
	userCountOneDay = null;

	userCountActive = null;

	userRetentionSixMonth = null;
	userRetentionThreeMonth = null;
	userRetentionOneMonth = null;
	userRetentionSevenDays = null;
	userRetentionOneDay = null;

	userCountInActive: any = {};

	userActiveNewCount = null;
	userActiveNewCountSixMonth = null;
	userActiveNewCountThreeMonth = null;
	userActiveNewCountOneMonth = null;
	userActiveNewCountSevenDays = null;
	userActiveNewCountOneDay = null;

	weeks: any = [];

	userPlatformDistribution = [];
	userPlatformDistributionTotal = 0;

	constructor(
		private userService: UserService) {
		this.dateSelectionRanges = [
			{
				name: "Today",
				start: moment().startOf("day").toDate(),
				end: moment().startOf("day").add(1, "day").add(-1, "second").toDate()
			},
			{
				name: "Yesterday",
				start: moment().add(-1, "day").startOf("day").toDate(),
				end: moment().startOf("day").add(-1, "second").toDate()
			},
			{
				name: "Last 7 Days",
				start: moment().add(-7, "day").startOf("day").toDate(),
				end: moment().startOf("day").add(1, "day").add(-1, "second").toDate()
			},
			{
				name: "Last Month",
				start: moment().add(-1, "month").startOf("day").toDate(),
				end: moment().startOf("day").add(1, "day").add(-1, "second").toDate()
			},
			{
				name: "Last 3 Month",
				start: moment().add(-3, "month").startOf("day").toDate(),
				end: moment().startOf("day").add(1, "day").add(-1, "second").toDate()
			},
			{
				name: "Last 6 Month",
				start: moment().add(-6, "month").startOf("day").toDate(),
				end: moment().startOf("day").add(1, "day").add(-1, "second").toDate()
			},
			{
				name: "Last Year",
				start: moment().add(-1, "year").startOf("day").toDate(),
				end: moment().startOf("day").add(1, "day").add(-1, "second").toDate()
			},
			{
				name: "All Time",
				start: moment("2018-01-01").startOf("day").toDate(),
				end: moment().startOf("day").add(1, "day").add(-1, "second").toDate()
			}
		];
		this.queryModel = new BaseGraphQueryModel();
	}

	reset() {
		this.userCount = null;

		this.userCountSixMonth = null;
		this.userCountThreeMonth = null;
		this.userCountOneMonth = null;
		this.userCountSevenDays = null;
		this.userCountOneDay = null;

		this.userCountActive = null;
		this.userRetentionSixMonth = null;
		this.userRetentionThreeMonth = null;
		this.userRetentionOneMonth = null;
		this.userRetentionSevenDays = null;
		this.userRetentionOneDay = null;

		this.userCountInActive = {};
		this.userActiveNewCount = null;
		this.userActiveNewCountSixMonth = null;
		this.userActiveNewCountThreeMonth = null;
		this.userActiveNewCountOneMonth = null;
		this.userActiveNewCountSevenDays = null;
		this.userActiveNewCountOneDay = null;

		this.userPlatformDistribution = [];
		this.userPlatformDistributionTotal = 0;
	}

	pastCounts(dateString?: string) {
		this.date = dateString == null ? moment() : moment(dateString);

		this.sixMonths = this.date.clone().add(-6, "month");
		this.threeMonths = this.date.clone().add(-3, "month");
		this.oneMonths = this.date.clone().add(-1, "month");
		this.sevenDays = this.date.clone().add(-7, "days");
		this.oneDay = this.date.clone().add(-1, "days");

		this.getUserCountBetween(this.sixMonths.toDate(), this.date.toDate()).then(x => this.userCountSixMonth = x);
		this.getUserCountBetween(this.threeMonths.toDate(), this.date.toDate()).then(x => this.userCountThreeMonth = x);
		this.getUserCountBetween(this.oneMonths.toDate(), this.date.toDate()).then(x => this.userCountOneMonth = x);
		this.getUserCountBetween(this.sevenDays.toDate(), this.date.toDate()).then(x => this.userCountSevenDays = x);
		this.getUserCountBetween(this.oneDay.toDate(), this.date.toDate()).then(x => this.userCountOneDay = x);

		this.getUsersActiveNew(this.sixMonths.toDate(), this.date.toDate()).then(x => this.userActiveNewCountSixMonth = x);
		this.getUsersActiveNew(this.threeMonths.toDate(), this.date.toDate()).then(x => this.userActiveNewCountThreeMonth = x);
		this.getUsersActiveNew(this.oneMonths.toDate(), this.date.toDate()).then(x => this.userActiveNewCountOneMonth = x);
		this.getUsersActiveNew(this.sevenDays.toDate(), this.date.toDate()).then(x => this.userActiveNewCountSevenDays = x);
		this.getUsersActiveNew(this.oneDay.toDate(), this.date.toDate()).then(x => this.userActiveNewCountOneDay = x);

		this.getUsersActive(this.sixMonths.toDate(), this.date.toDate()).then(x => this.userRetentionSixMonth = x);
		this.getUsersActive(this.threeMonths.toDate(), this.date.toDate()).then(x => this.userRetentionThreeMonth = x);
		this.getUsersActive(this.oneMonths.toDate(), this.date.toDate()).then(x => this.userRetentionOneMonth = x);
		this.getUsersActive(this.sevenDays.toDate(), this.date.toDate()).then(x => this.userRetentionSevenDays = x);
		this.getUsersActive(this.oneDay.toDate(), this.date.toDate()).then(x => this.userRetentionOneDay = x);
	}

	ngOnInit() {
		this.filter();
	}

	setDate(from: Date, to: Date) {
		if (from != null && to != null) {
			this.dateRange = new Array(2);
			this.dateRange[0] = from;
			this.dateRange[1] = to;
		} else {
			this.dateRange = null;
		}

		this.filter();
	}

	filter() {
		this.queryModel.dateFrom = this.dateRange != null && this.dateRange[0] != null ? this.dateRange[0].toISOString() : null;
		this.queryModel.dateTo = this.dateRange != null && this.dateRange[1] != null ? this.dateRange[1].toISOString() : null;

		if (this.queryModel.dateFrom != null && this.queryModel.dateTo == null) {
			return;
		}

		this.reset();

		this.pastCounts(this.queryModel.dateTo);
		this.getUserCount();
		this.getUsersActiveNewCount();
		this.getUserCountActive();
		this.getUserCountInActive();
		this.getPlatformCount();
		this.getWeeklySplit();
	}

	getUserCount() {
		this.userService.getUserCount(this.queryModel).then(
			result => {
				this.userCount = result;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	getUserCountBetween(from: Date, to: Date) {
		var model = new BaseGraphQueryModel();
		model.dateFrom = from.toISOString();
		model.dateTo = to.toISOString();
		return this.userService.getUserCount(model);
	}

	getUserCountActive() {
		this.userService.getUserCountActive(this.queryModel).then(
			result => {
				this.userCountActive = result;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	getUsersActive(from: Date, to: Date) {
		var model = new BaseGraphQueryModel();
		model.dateFrom = from.toISOString();
		model.dateTo = to.toISOString();
		return this.userService.getUserCountActive(model);
	}

	getUsersActiveNewCount() {
		this.userService.getUserCountActiveNew(this.queryModel).then(
			result => {
				this.userActiveNewCount = result;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	getUsersActiveNew(from: Date, to: Date) {
		var model = new BaseGraphQueryModel();
		model.dateFrom = from.toISOString();
		model.dateTo = to.toISOString();
		return this.userService.getUserCountActiveNew(model);
	}

	getUserCountInActive() {
		this.userService.getUserCountInActive(this.queryModel).then(
			result => {
				this.userCountInActive = result;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	downloading: boolean;
	downloadUserCountInActive(event) {
		event.stopPropagation();
		this.downloading = true;
		this.userService.downloadUserCountInActive(this.queryModel).subscribe(
			blob => {
				console.log(blob);
				this.downloading = false;
				saveAs(blob, "report.zip");
			},
			error => {
				this.downloading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	getWeeklySplit() {
		this.weeks = [];
		let to = this.dateRange != null && this.dateRange[1] != null ? moment(this.dateRange[1]) : moment().endOf('month');
		let from = to.clone().startOf("month");
		while (from < to) {
			var start = from.clone();
			var end = from.clone().add(6, "days").endOf("day");
			var data = {
				start: start,
				end: end,
				users: null,
				active: null
			};

			this.weeks.push(data);
			from.add(7, "days").startOf("day");
		}

		let promises = [];
		for (var split of this.weeks) {
			promises.push(this.getUserCountBetween(split.start.toDate(), split.end.toDate()));
			promises.push(this.getUsersActiveNew(split.start.toDate(), split.end.toDate()));
		}

		Promise.all(promises).then(x => {
			let index = 0;
			for (let i = 0; i < x.length; i += 2) {
				this.weeks[index].users = x[i];
				this.weeks[index].active = x[i + 1];
				++index;
			};
		});
	}

	getPlatformCount() {
		this.userPlatformDistribution = [];
		this.userPlatformDistributionTotal = 0;
		this.userService.getUserPlatformDistribution(this.queryModel).then(
			result => {
				this.userPlatformDistribution = result;
				this.userPlatformDistributionTotal = this.userPlatformDistribution.reduce((accumulator, object) => {
					return accumulator + object.y;
				}, 0);
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/admin/user-dashboard/user-dashboard.component.ts